import { formatSecondsAsTimer } from "@vericus/cadmus-common";
import { Alert, colors, Pill } from "@vericus/cadmus-ui";

import { LabelledPill } from "./labelled-pill";
import * as styles from "./response-requirements.css";

export interface ResponseRequirementsProps {
  responseTimeSeconds: number | null;
  preparationTimeSeconds: number | null;
  baseMaxAttempts: number | null;
  studentMaxAttempts: number | null;
  vivaReattemptWindowTime: number | null;
  hasSubmittedResponse?: boolean;
}

export function ResponseRequirements(props: ResponseRequirementsProps) {
  const {
    responseTimeSeconds,
    preparationTimeSeconds,
    baseMaxAttempts,
    studentMaxAttempts,
    vivaReattemptWindowTime,
    hasSubmittedResponse = false,
  } = props;

  const hasLimitedAttempts =
    studentMaxAttempts != null && studentMaxAttempts > 1;

  const extraAttempts =
    studentMaxAttempts != null &&
    baseMaxAttempts != null &&
    studentMaxAttempts > baseMaxAttempts
      ? studentMaxAttempts - baseMaxAttempts
      : 0;

  const showReattemptBanner =
    vivaReattemptWindowTime != null && hasLimitedAttempts && !hasSubmittedResponse;

  return (
    <div className={styles.root}>
      <div className={styles.tagRow}>
        <LabelledPill
          label="Response time"
          value={`${formatSecondsAsTimer(responseTimeSeconds ?? 0)} min`}
        />

        {preparationTimeSeconds != null && preparationTimeSeconds > 0 && (
          <LabelledPill
            label="Preparation time"
            value={`${formatSecondsAsTimer(preparationTimeSeconds)} min`}
          />
        )}

        {hasLimitedAttempts && (
          <LabelledPill
            label="Attempts"
            value={String(studentMaxAttempts)}
            extra={
              extraAttempts > 0 ? (
                <Pill basic lowerCase>{`+${extraAttempts} Extra`}</Pill>
              ) : undefined
            }
          />
        )}
      </div>
      {showReattemptBanner && (
        <Alert
          severity="warning"
          size="sm"
          overrides={{ bg: colors.orange100 }}
          className={styles.reattemptAlert}
        >
          Re-attempts will expire{" "}
          <b>
            {vivaReattemptWindowTime} minute{plural(vivaReattemptWindowTime)}
          </b>{" "}
          after you finish your first recording
        </Alert>
      )}
    </div>
  );
}

function plural(count: number) {
  return count === 1 ? "" : "s";
}
